import "core-js/modules/es6.object.to-string.js";
export default {
  methods: {
    asyncScript: function asyncScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        var s = document.getElementsByTagName('script')[0];
        script.onload = resolve;
        script.onerror = reject;
        script.type = 'text/javascript';
        script.async = true;
        script.src = src;
        s.parentNode.insertBefore(script, s);
      });
    }
  }
};